/** docs/design/35 section 8.1: who may open the reports area (the backend enforces the same roles). */
export const REPORT_ROLES = ['SystemAdmin', 'FacilityManager'] as const;
